import { render, staticRenderFns } from "./Correo.vue?vue&type=template&id=8b59b0c0&"
import script from "./Correo.vue?vue&type=script&lang=js&"
export * from "./Correo.vue?vue&type=script&lang=js&"
import style0 from "./Correo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports